const dicText_jp = {
  menu: {
    home: "ホーム",
    services: "サービス",
    ability: "テックスタック",
    works: "製品",
    company: "会社情報",
    contact: "お問い合わせ",
  },
  home: {
    intro_1: `今エネルギー業界は、これまで経験したことがないような大きな変革期を見変えています。
      <br />
      私たちは、「エネルギー市場」というステージで、
      時代の潮流に応じて自らを変革することで
      「デジタルトランスフォーマー」の地位を確立し、
      地域の皆さまの発展につなげて参ります。`,
    intro_2:
      "いま電力業界は、これまで経験したことがないような大きな変革期を迎えています。<br />OpenQuantは、「電力市場」というステージで、<br />時代の潮流に応じて自らを変革することで「トレーディング専門会社」の姿に、<br />地域の皆さまの発展につなげて参ります。",
  },
  works: {
    main_title: "Works & Case",
    sub_title: "",
    prod_OEMS: {
      title: "顧客管理システム",
      desc: "顧客情報・使用量・電気料金を管理する顧客管理システムです。小売電気事業者様における顧客情報の管理や需給状況の確認、需要家様における使用量の見える化や料金確認機能をご提供します。",
    },
    grid_sync: {
      title: "需給管理システム",
      desc: "需要予測・電源調達・計画作成を管理する需給管理システムです。AI需要予測、同時同量監視、小売・発電・FIT特例１ポジション、計画提出、JEPXスポットと時間前入札などのフルパッケージ機能をご提供します。",
    },
    prod_futsMS: {
      title: "電力現物・先物管理システム",
      desc: "電力現物取引とそれに付随するデリバティブ取引を管理するコモディティ取引・リスク管理システムです。電力の現物・先物取引・売買管理で生じるポジション管理について、正確かつ効率的に処理することが可能です。",
    },
    flex_trading_2: {
      title: "デマンドレスポンスシステム",
      desc: "需要家から実際に使用した電力を収集し、あらかじめ設定したベースラインをクリアしたかを判断するシステムです。需要家へ節電の通知、インセンティブの計算、レポートの抽出を実現します。",
    },
    strgy_master_pro: {
      title: "StrategyMasterPro",
      desc: "取引ストラテジーの開発プラットフォーム。株式、先物、外国為替、貴金属、仮想通貨など、取引対象は幅広くカバーします。トレードアイデアの視覚化、量的戦略の品質評価、取引シグナルとポジション管理の実現、およびさまざまな取引プラットフォームへの接続が可能です。",
    },
    flex_flow: {
      title: "FlexFlow",
      desc: "カスタマイズ可能なワークフローシステム。複数のプラットフォームでのデータ提出、承認、および審査に使用できるだけでなく、日常業務の経費や出勤などの承認にも利用できます。",
    },
  },
  services: {
    main_title: "Services",
    sub_title: "私たちは、以下の４つのサービスをご提供しています。",
    system_dev: {
      title: "①	顧客情報管理＆請求処理",
      desc: "見込み顧客登録から請求処理、そして回収まで、顧客ライフサイクル全体に対応します。さらに、複雑な料金設定、例外処理、レポートおよびカスタマーポータルといった各種機能も提供します。",
    },
    algorithms: {
      title: "②	需給管理",
      desc: "電力需要の予測と太陽光発電所の発電管理・発電予測を支援するWebアプリケーションです。データに基づく効率的なエネルギーマネジメントを実現します。",
    },
    data_hub: {
      title: "③	データリンクトランザクション管理",
      desc: "エネルギー企業と多種多様な組織との間のデータ交換のためのあらゆる要件をサポートします。これには、システムの実装、テスト、認証、運用および例外処理も含まれます。",
    },
    strgy_dev: {
      title: "④	自動アルゴトレーディング",
      desc: "エネルギー事業者向けに自動アルゴトレーディング・プラットフォームを提供し、取引の最適化をサポートします。",
    },
  },
  ability: {
    main_title: "Main Tech Stack",
    sub_title:
      "私たちは情報システムの開発、統合、運用経験があり、以下の技術スタックを持っています。",
    front_end: {
      title: "Front End",
      desc: "React / VUE / TypeScript / JavaScript",
    },
    back_end: {
      title: "Back End",
      desc: "Golang / Nodejs / Python",
    },
    algorithms: {
      title: "Algorithms",
      desc: "C++ / Python / MQL",
    },
    cloud: {
      title: "Cloud Platform",
      desc: "AWS / Azure",
    },
  },
  partner: {
    main_title: "パートナー",
    igent: {
      name: "アイジェント株式会社",
      desc: "オフショア開発を中心に、中国を拠点としたシステム開発支援など企画戦略から運用までワンストップでサポートしております。ベスト・ソリューションパートナーとして、お客様の新しい価値の共創に尽力させていただきます。",
      website: "http://www.igent-tech.com",
    },
    hengxun: {
      name: "大連恒迅華成科技株式会社",
      desc: "中国の大連に於けるITサービス会社です。日本に向け、中国国内に向け大規模な開発や派遣は可能です。",
      website: "http://www.hengxun-tech.com",
    },
  },
};
const dicText_cn = {
  menu: {
    home: "home",
    services: "services",
    ability: "tech-stack",
    works: "works",
    company: "company",
    contact: "contact us",
  },
  home: {
    intro_1:
      "在 0 与 1 的信息世界中，发现无穷的可能。<br />搜集既有数据，<br />生成新数据，<br />发现关联数据，以数据创作价值。",
  },
  works: {
    main_title: "Works & Case",
    sub_title: "",
    prod_OEMS: {
      title: "OEMS",
      desc: "顧客の見込み、入退会、請求の自動作成、そして回収まで、顧客ライフサイクル全体に対応するシステムです。さらにさまざまなデータ処理、ビッグデータ分析、データ可視化、および統計レポート生成を提供します。",
    },
    grid_sync: {
      title: "需給管理システム",
      desc: "需要予測・電源調達・計画作成を管理する需給管理システムです。AI需要予測、同時同量監視、小売・発電・FIT特例１ポジション、計画提出、JEPXスポットと時間前入札などのフルパッケージ機能をご提供します。",
    },
    prod_futsMS: {
      title: "電力先物・現物ヘッジシステム",
      desc: "本システムは、電力オプションと先物を利用して、JEPX電力現物市場の価格変動をヘッジします。システム機能には、価格分析、ピークロード/ベースロード試算、損益分岐点分析、決済およびレポートなどが含まれます。",
    },
    data_hub_x: {
      title: "DataHubX",
      desc: "灵活地收集各种异构数据，包括Excel文件、CSV文件、PDF文件以及各种数据库。数据被抽取转换并存储为统一的格式，并提供后续的数据再加工，大数据分析以及数据可视化及统计报告生成。",
    },
    strgy_master_pro: {
      title: "StrategyMasterPro",
      desc: "一款交易策略的开发平台。交易标的涵盖股票，期货，外汇，贵金属，数字货币等。<br/> 可以可视化寻找交易思路，量化策略品质，实现交易信号和仓位管理，并可挂载到各交易平台。",
    },
    flex_flow: {
      title: "FlexFlow",
      desc: "一套轻量级可定制的工作流系统，可用于多端数据提交审批复核，也可用于日常办公的经费出勤事务等审批。",
    },
    flex_trading_2: {
      title: "FlexTrading2",
      desc: "一套量化自动交易策略，可以在趋势和震荡走势中自主切换模式，在低风险的前提下获取稳定的可预期收益。",
    },
  },
  services: {
    main_title: "Our Services",
    sub_title: "我们围绕数据分析处理，提供上下游周边的咨询与开发实施。",
    data_hub: {
      title: "データ連携・統合基盤の構築",
      desc: "オンプレミスやクラウド環境に分散するデータを管理し、統合ソリューションを導入することで、社内外の様々なシステムのデータ連携を実現します。 様々なフォーマットのデータを収集して、連携先のシステムに適したフォーマットに加工・出力します。",
    },
    algorithms: {
      title: "データ分析・アルゴリズム実装",
      desc: "データ分析を通じて構築されたアルゴリズムをシステムに実装します。",
    },
    system_dev: {
      title: "受託開発・運用・保守支援",
      desc: "データ処理システムの新規開発、既存システムの改修などサービスを提供しています。システムのホスティング、システムを監視して安定運転を確保することを行います",
    },
    strgy_dev: {
      title: "金融取引アルゴリズム、自動取引システムの実装",
      desc: "多因子时间序列算法开发，金融交易策略的实现以及自动化交易系统的构筑。",
    },
  },
  ability: {
    main_title: "Main Tech Stack",
    sub_title: "团队有信息系统开发，集成，运维经验，技术栈如下",
    front_end: {
      title: "Front End",
      desc: "React / VUE / TypeScript / JavaScript",
    },
    back_end: {
      title: "Back End",
      desc: "Golang / Nodejs / Python",
    },
    algorithms: {
      title: "Algorithms",
      desc: "C++ / Python / MQL",
    },
    cloud: {
      title: "Cloud Platform",
      desc: "AWS / Azure",
    },
  },
  partner: {
    main_title: "パートナー",
    igent: {
      name: "アイジェント株式会社",
      desc: "オフショア開発を中心に、中国を拠点としたシステム開発支援など企画戦略から運用までワンストップでサポートしております。ベスト・ソリューションパートナーとして、お客様の新しい価値の共創に尽力させていただきます。",
      website: "http://www.igent-tech.com",
    },
    hengxun: {
      name: "大連恒迅華成科技株式会社",
      desc: "中国の大連に於けるITサービス会社です。日本に向け、中国国内に向け大規模な開発や派遣は可能です。",
      website: "http://www.hengxun-tech.com",
    },
  },
};
const dicText_en = {
  menu: {
    home: "home",
    services: "services",
    ability: "tech-stack",
    works: "works",
    company: "company",
    contact: "contact us",
  },
  home: {
    intro_1:
      "0と1の情報の世界で、無限の可能性を発見しましょう。<br />既存のデータを収集し、<br />新しいデータを生成し、<br />関連データを見つけ、<br />データを活用して価値を創造しましょう。",
  },
  works: {
    main_title: "Works & Case",
    sub_title: "",
    prod_OEMS: {
      title: "顧客管理システム",
      desc: "顧客の見込み、入退会、請求の自動作成、そして回収まで、顧客ライフサイクル全体に対応するシステムです。さらにさまざまなデータ処理、ビッグデータ分析、データ可視化、および統計レポート生成を提供します。",
    },
    grid_sync: {
      title: "需給管理システム",
      desc: "需要予測・電源調達・計画作成を管理する需給管理システムです。AI需要予測、同時同量監視、小売・発電・FIT特例１ポジション、計画提出、JEPXスポットと時間前入札などのフルパッケージ機能をご提供します。",
    },
    prod_futsMS: {
      title: "電力先物・現物ヘッジシステム",
      desc: "本システムは、電力オプションと先物を利用して、JEPX電力現物市場の価格変動をヘッジします。システム機能には、価格分析、ピークロード/ベースロード試算、損益分岐点分析、決済およびレポートなどが含まれます。",
    },
    data_hub_x: {
      title: "DataHubX",
      desc: "Flexibly collect heterogeneous data, including various data formats such as Excel files, CSV files, PDF files, and various databases. Extract and organize the data into a unified format, store it in a database, and provide subsequent data analytics and report generation.",
    },
    strgy_master_pro: {
      title: "StrategyMasterPro",
      desc: "一款交易策略的开发平台。交易标的涵盖股票，期货，外汇，贵金属，数字货币等。<br/> 可以可视化寻找交易思路，量化策略品质，实现交易信号和仓位管理，并可挂载到各交易平台。",
    },
    flex_flow: {
      title: "FlexFlow",
      desc: "一套轻量级可定制的工作流系统，可用于多端数据提交审批复核，也可用于日常办公的经费出勤事务等审批。",
    },
    flex_trading_2: {
      title: "FlexTrading2",
      desc: "一套量化自动交易策略，可以在趋势和震荡走势中自主切换模式，在低风险的前提下获取稳定的可预期收益。",
    },
  },
  services: {
    main_title: "Our Services",
    sub_title: "我们围绕数据分析处理，提供上下游周边的咨询与开发实施。",
    data_hub: {
      title: "データ連携・統合基盤の構築",
      desc: "オンプレミスやクラウド環境に分散するデータを管理し、統合ソリューションを導入することで、社内外の様々なシステムのデータ連携を実現します。 様々なフォーマットのデータを収集して、連携先のシステムに適したフォーマットに加工・出力します。",
    },
    algorithms: {
      title: "データ分析・アルゴリズム実装",
      desc: "データ分析を通じて構築されたアルゴリズムをシステムに実装します。",
    },
    system_dev: {
      title: "受託開発・運用・保守支援",
      desc: "データ処理システムの新規開発、既存システムの改修などサービスを提供しています。システムのホスティング、システムを監視して安定運転を確保することを行います",
    },
    strgy_dev: {
      title: "金融取引アルゴリズム、自動取引システムの実装",
      desc: "Development of multi-factor time series algorithms, implementation of financial trading strategies, and construction of an automated trading system.",
    },
  },
  ability: {
    main_title: "Main Tech Stack",
    sub_title: "团队有信息系统开发，集成，运维经验，技术栈如下",
    front_end: {
      title: "Front End",
      desc: "React / VUE / TypeScript / JavaScript",
    },
    back_end: {
      title: "Back End",
      desc: "Golang / Nodejs / Python",
    },
    algorithms: {
      title: "Algorithms",
      desc: "C++ / Python / MQL",
    },
    cloud: {
      title: "Cloud Platform",
      desc: "AWS / Azure",
    },
  },
  partner: {
    main_title: "パートナー",
    igent: {
      name: "アイジェント株式会社",
      desc: "オフショア開発を中心に、中国を拠点としたシステム開発支援など企画戦略から運用までワンストップでサポートしております。ベスト・ソリューションパートナーとして、お客様の新しい価値の共創に尽力させていただきます。",
      website: "http://www.igent-tech.com",
    },
    hengxun: {
      name: "大連恒迅華成科技株式会社",
      desc: "中国の大連に於けるITサービス会社です。日本に向け、中国国内に向け大規模な開発や派遣は可能です。",
      website: "http://www.hengxun-tech.com",
    },
  },
};

let dic: any = dicText_jp;

const setCurLang = (lang: string) => {
  if (lang === "cn") {
    dic = dicText_cn;
  } else if (lang === "en") {
    dic = dicText_en;
  } else {
    dic = dicText_jp;
  }
};

export { dic, setCurLang };
